import { FunctionComponent, PropsWithChildren, ReactElement } from 'react';

import { FormControl } from '@mui/material';

import BaseAutocomplete from '../../../../../../../shared/components/base-autocomplete/base-autocomplete';
import BaseRenderInput from '../../../../../../../shared/components/base-autocomplete/components/base-render-input/base-render-input';
import { useAppDispatch } from '../../../../../../../store/hooks';
import { filterReviewsByRating } from '../../../store/slices/slices/reviews.slice';
import { AllReviewsFiltersProps } from '../types/all-reviews-filters-props';
import withFilterValues from './with-filter-values';

const RatingsDropdown: FunctionComponent<AllReviewsFiltersProps> = (
  props: PropsWithChildren<AllReviewsFiltersProps>
): ReactElement => {
  const dispatch = useAppDispatch();

  const { setFieldValue, filterValues } = props;

  return (
    <FormControl
      data-testid="ratings-dropdown"
      key="ratings-filter"
      classes={{
        root: 'form-control-main',
      }}
    >
      <BaseAutocomplete
        id="rating"
        freeSolo={false}
        multiple={false}
        value={filterValues?.rating || null}
        options={[1, 2, 3, 4, 5].map(x => x.toString())}
        onChange={(event, value) => {
          setFieldValue('rating', value);
          dispatch(filterReviewsByRating(value ?? ''));
        }}
        renderInput={params => (
          <BaseRenderInput
            {...params}
            id="rating"
            label="Rating"
            name="rating"
            errors={props.errors}
            touched={props.touched}
          />
        )}
      />
    </FormControl>
  );
};

export default withFilterValues(RatingsDropdown);
